/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

// Cloudinary podržava transformacije kroz URL — ubacivanjem parametara posle
// /upload/ dobijamo smanjenu, automatski kompresovanu verziju umesto originala
// (koji može biti do 9 MB). Za ne-Cloudinary URL-ove vraća original.
export const cloudinaryThumb = (url, width = 600) => {
  if (!url || typeof url !== 'string') return url;
  const marker = '/upload/';
  const idx = url.indexOf(marker);
  if (idx === -1 || !url.includes('res.cloudinary.com')) return url;
  const afterUpload = url.slice(idx + marker.length);
  // Već transformisan URL ne diramo.
  if (/^[a-z]+_[^/]*\//.test(afterUpload)) return url;
  return `${url.slice(0, idx + marker.length)}w_${width},c_limit,q_auto,f_auto/${afterUpload}`;
};
